// This file is generated, do not edit! See ../scripts/generate-index.ts
import * as I from './internals';
export function compose(optic1, optic2) {
    return optic1.compose(optic2);
}
export function optic() {
    return I.optic;
}
export function optic_() {
    return I.optic;
}
export function get(optic) {
    return function (source) { return I.get(optic._ref, source); };
}
export function preview(optic) {
    return function (source) { return I.preview(optic._ref, source); };
}
export function collect(optic) {
    return function (source) { return I.collect(optic._ref, source); };
}
export function modify(optic) {
    return function (f) { return function (source) { return I.modify(optic._ref, f, source); }; };
}
export function set(optic) {
    return function (value) { return function (source) { return I.set(optic._ref, value, source); }; };
}
export function remove(optic) {
    return function (source) { return I.remove(optic._ref, source); };
}
export function pipe(a, ab, bc, cd, de, ef, fg, gh, hi, ij) {
    switch (arguments.length) {
        case 1:
            return a;
        case 2:
            return ab(a);
        case 3:
            return bc(ab(a));
        case 4:
            return cd(bc(ab(a)));
        case 5:
            return de(cd(bc(ab(a))));
        case 6:
            return ef(de(cd(bc(ab(a)))));
        case 7:
            return fg(ef(de(cd(bc(ab(a))))));
        case 8:
            return gh(fg(ef(de(cd(bc(ab(a)))))));
        case 9:
            return hi(gh(fg(ef(de(cd(bc(ab(a))))))));
        case 10:
            return ij(hi(gh(fg(ef(de(cd(bc(ab(a)))))))));
    }
    return;
}
